import { IFormService } from "../../service/form/FormService";

export default class ChangeFormAttributeInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(
    formAttributeId: number,
    blob: any,
    valueClob: string,
    valueDate: Date,
    valueNumber: number,
    valueReferenceId: any,
    valueReference: string,
    valueString: string,
    mimeType: string
  ) {
    return this.formService.changeFormAttribute(
      formAttributeId,
      blob,
      valueClob,
      valueDate,
      valueNumber,
      valueReferenceId,
      valueReference,
      valueString,
      mimeType
    );
  }
}
